// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__YmBWczBZ","wrapperContent":"wrapper-content__o2UCRmSF"};